<template>
  <div>
    <Modal v-model="visible" width="85" :title="title" :footer-hide="true" :mask-closable="false" class="my-modal vertical-center-modal">
      <div class="batchMatching">
        <div class="searchValueBtn">
          <Input v-model.trim="searchParams.value" :autosize="{ minRows: 4, maxRows: 10 }" type="textarea" placeholder="请输入保单号或批单号，多个保单号换行输入，如果是批单，请先写保单号，空一格后面输入批单号" />
          <Button type="primary" @click="matchPolicy">匹配保单</Button>
        </div>
        <div class="batchBtn">
          <span class="toggleBtn" @click="visible1 = true">输入示例</span>
        </div>
        <div class="matchingResult" v-if="unmatchedList.length>0">
          <Alert type="warning">
            <i class="iconfont iconzhuyi1"></i>
            <span class="textResult">未匹配到的保单号/批单号：（系统无此保单/批单、系统无费用数据、不属于团财保单、不属于结算报表类型、不属于结算机构的数据）</span>
              <template #desc>
                <div v-for="(item,index) in unmatchedList" :key="index">
                  {{ item }}
                </div>
              </template>
          </Alert>
        </div>

        <div v-if="showTable">
          <div class="search-box">
            <div class="input-item">
                <span slot="label" class="label">
                  是否扣款记录<span class="tip-icon">?</span>
                  <div class="pop-tip">
                    <span>因退保等原因已扣除费用的记录</span>
                    <div class="arrow"></div>
                  </div>
                </span>

                <RadioGroup v-model="searchParams.queryDeduct"  @on-change="getList">
                  <Radio label="">全部</Radio>
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
              </div>
              <div class="btn-item">
              <Button type="primary" @click="getList">查询</Button>
            </div>
          </div>

          <!-- 工具栏 -->
          <div class="tools-box">
            <div class="left-box">
              <Checkbox v-model="isAll" @on-change="selectAll">全部</Checkbox>
            </div>
            <div class="right-box">
              <span class="text"
                >已选择<span>{{ isAll ? total : selectArr.length }}</span
                >条，共<span>{{ total }}</span
                >条数据</span
              >
            </div>
          </div>

          <div class="tableBox">
            <loading :isShow="listLoading" />
            <Table :columns="columns" :data="tableData" @on-selection-change="onSelectChange"> 
              <template slot-scope="{ row }" slot="reconciliationStatusDesc">
                <div>
                  {{ getReconciliationStatus(row.reconciliationStatus) }}
                </div>
              </template>
            </Table>
          </div>
          <Page
            :total="total"
            :current.sync="pageNum"
            :page-size="pageSize"
            show-total
            @on-change="getList"
            style="text-align: center; margin-top: 20px; margin-bottom: 20px"
          />
        </div>
        

        <div class="ivu-modal-footer">
          <Button size="default" @click="visible = false">取消</Button>
          <Button type="primary" size="default" @click="ok" v-preventReClick>加入结算报表</Button>
        </div>
      </div>
    </Modal>

    <Modal v-model="visible1" width="600" :title="title1" :footer-hide="true" :mask-closable="false" class="my-modal top">
      <div class="tipsTitle">
        每一行一个保单号或保单号+批单号
      </div>
      <Input v-model="value" :disabled="true" :rows="4" type="textarea" placeholder="请输入保单号，多个保单号换行输入，可粘贴" />
    </Modal>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filter from '@/api/filter';
export default {
  mixins: [pageTool, common],
  props: ['reportId'],
  data() {
    return {
      title:'请输入保单号/批单号选择结算数据',
      title1:'输入示例',
      visible: false,
      value:'',
      visible1:false,
      showTable:false,
      unmatchedList:[],
      searchParams:{
        value:'',
      },
      isAll: false, //全部产品
      total: null,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '保单号',
          align: 'center',
          key: 'policyNo',
          minWidth: 160,
          fixed: 'left'
        },
        {
          title: '批单号',
          align: 'center',
          key: 'billNo',
          minWidth: 180,
          render(h, params) {
            let billNo = params.row.billNo;
            return <span>{billNo ? billNo : '-'}</span>;
          },
          fixed: 'left'
        },
        {
          title: '保险公司',
          align: 'center',
          key: 'companyName',
          minWidth: 160
        },
        {
          title: '保险产品',
          align: 'center',
          key: 'productName',
          minWidth: 280
        },
        {
          title: '险种名称',
          align: 'center',
          key: 'insuranceName',
          minWidth: 300
        },
        {
          title: '保单状态',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if (params.row.policyStatus == 1) {
              return <span>已承保</span>;
            } else if (params.row.policyStatus == '0') {
              return <span>已终止</span>;
            } else if (params.row.policyStatus == 2) {
              return <span>续保</span>;
            } else if (params.row.policyStatus == -1) {
              return <span>已退保</span>;
            } else {
              return <span>-</span>;
            }
          }
        },
        {
          title: '承保日期',
          align: 'center',
          key: 'insureTime',
          minWidth: 130,
          render(h, params) {
            let insureTime = params.row.insureTime;
            return <span>{filter.filterTime(insureTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '生效日期',
          align: 'center',
          key: 'effectTime',
          minWidth: 130,
          render(h, params) {
            let effectTime = params.row.effectTime;
            return <span>{filter.filterTime(effectTime, 'YYYY-MM-DD')}</span>;
          }
        },
        {
          title: '保费',
          align: 'center',
          key: 'fee',
          minWidth: 100
        },
        {
          title: '费用归属',
          align: 'center',
          key: 'owerName',
          minWidth: 200,
        },
        {
          title: '费用类型',
          align: 'center',
          key: 'owerType ',
          minWidth: 160,
          render(h, params) {
            const commissionType = params.row.commissionType;
            if (commissionType == 1) {
              return <span>基础费用</span>;
            } else if (commissionType == 11) {
              return <span>限时加费活动</span>;
            }else if(commissionType == 13){
              return <span>梯度加费</span>;
            }
          },
        },
        { 
          title: '净费率',
          align: 'center',
          key: 'netCommission',
          minWidth: 100,
          render(h, params) {
            const netCommission = params.row.netCommission;
            return <span>{netCommission ? netCommission + '%' : '-'}</span>;
          }
        },
        {
          title: '净收入',
          align: 'center',
          minWidth: 150,
          render(h, params) {
            const netIncome = params.row.netIncome;
            const deductType = params.row.deductType;
            let msg = '';
            if (deductType == 1) {
              msg = '退保';
            } else if (deductType == 4) {
              msg = params.row.deductMsg;
            }
            let isDeduct = params.row.isDeduct;
            if (isDeduct == '1') {
              return (
                <div style="display:flex; align-items: center; justify-content: center;">
                  <span>{netIncome ? netIncome : '-'}</span>
                  <Poptip trigger="hover" placement="top-end" transfer-class-name="my-poptip min-width" transfer={true}>
                    <span style="height:20px; width:34px; font-size: 12px; border: 1px solid #ffcf8e; background: #fff3e3; color: #ff7f00; margin-left: 5px; padding: 2px 2px; cursor: pointer;">
                      扣款
                    </span>
                    <div slot="content">
                      <p>{msg}</p>
                    </div>
                  </Poptip>
                </div>
              );
            } else {
              return <span>{netIncome ? netIncome : '-'}</span>;
            }
          }
        },
        {
          title: '出单人',
          align: 'center',
          key: 'salesmanName',
          minWidth: 120
        }

      ],
      tableData: [],
      selectArr: [], //表格选择的数据
    };
  },
  methods:{
    getReconciliationStatus(item){
      if(item == '0'){
        return '未对账'
      }else if(item == '1'){
        return '对账正常'
      }else if(item == '2'){
        return '对账异常'
      }else if(item == '3'){
        return '已对账'
      }
    },
    matchPolicy(){
      if(!this.searchParams.value){
        this.$notice.msg("请输入保单号再匹配")
        return
      }
      let code = null 
      //去除换行
      code = this.searchParams.value.split(/[(\r\n)\r\n]+/)
      code.forEach((item, index) => { // 删除空项
        if (item == '\t' || item == '') {
              code.splice(index, 1);
            }
      })
      this.searchParams.noList = code 
      this.getList();
      this.getUnmatchedResult()
      this.showTable = true
    },
    ok() {
      if (!this.isAll && this.selectArr.length == 0) {
        this.$notice.msg("请至少选择一条记录")
        return;
      }
      let params = {};
      if (this.isAll) {
        params = {
          noList:this.searchParams.noList,
          reportId: this.reportId,
          isAll: 1,
          commissionLogNeedSettleDTOList: this.tableData,
          commissionLogNeedQuery: {
            type: '2'
          }
        };
      } else {
        params = {
          noList:this.searchParams.noList,
          reportId: this.reportId,
          isAll: 0,
          commissionLogNeedSettleDTOList: this.selectArr
        };
      }
      this.$http({
        url: '/buz/settlementData/saveData',
        type: 'POST',
        data: params
      }).then(res => {
        this.visible = false;
        this.$notice.success('加入结算成功');
        this.$emit('success');
      });
    },
    open(orgIds){
      this.visible = true
      this.isAll = false;
      this.searchParams={
        value:'',
        owerIds:orgIds
      }
      this.value = "00123456789008087\n00123456789008088  pd33552333333\n00123456789008089\n..."
      this.unmatchedList = []
      this.selectArr = [];
      this.showTable = false
    },
    // 查询
    searchAjax() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getUnmatchedResult() {
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionLog/queryOrgNoMatchSettleBySearchPolicyNos',
        type: 'POST',
        data: {
          type: '2',
          ...this.searchParams
        }
      })
        .then(res => {
          this.unmatchedList = res.data
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    // 获取列表
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/commissionLog/queryOrgNeedSettleBySearchPolicyNos',
        type: 'POST',
        data: {
          pageNo: this.pageNum,
          pageSize: this.pageSize,
          type: '2',
          ...this.searchParams
        }
      })
        .then(res => {
          res.data.forEach(item => {
            this.selectArr.forEach(item2 => {
              if (item.id == item2.id) {
                item._checked = true;
              }
            });
            if (this.isAll) {
              item._checked = true;
              item._disabled = true;
            }
          });
          this.total = res.total;
          this.tableData = res.data;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    changeValue(value){
      this.searchParams[value] = this.searchParams[value].replace(/^0(0+)|[^\d]+/g, '') 
      this.searchParams[value] = this.searchParams[value] && Number(this.searchParams[value])
      return this.searchParams[value]
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 列表选中
    onSelectChange(curSelectArr) {
      const ids = curSelectArr.map(item => item.id); //当前页勾选的
      const selectIds = this.selectArr.map(item => item.id); //已经添加的数据
      this.tableData.forEach(item => {
        if (ids.includes(item.id) && !selectIds.includes(item.id)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item);
          selectIds.push(item.id);
        } else if (!ids.includes(item.id) && selectIds.includes(item.id)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectIds.indexOf(item.id), 1);
          selectIds.splice(selectIds.indexOf(item.id), 1);
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .ivu-modal-body{
  max-height: 90vh !important;
}
/deep/ .ivu-input {
    &::placeholder{
      color: #999;
    }
  }
.matchingResult{
  margin-bottom: 20px;
  
  .textResult{
    font-size: 15px;
    margin-left: 5px;
  }
}

.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
}
.vertical-center-modal .ivu-modal{
    top: 0;
}
.iconzhuyi1{
  color: #ffb300;
  margin-right: 2px;
}
/deep/ .ivu-alert-desc{
  margin-left: 25px;
}

.batchMatching{
  margin-top: 20px;
  .searchValueBtn{
    display: flex;
    align-items: center;
    /deep/ .ivu-btn{
      min-width: 100px;
      margin-left: 10px;
    }
  }
  .batchBtn{
    display: flex;
    justify-content: space-between;
    margin: 10px 0;
    .toggleBtn {
      color: #2d8cf0;
      &:hover {
        cursor: pointer;
      }
    }
  }
  
}
.tipsTitle{
  margin: 20px 0;
}
.ivu-alert{
  height: 160px;
  overflow-y:scroll;
}
.label {
  position: relative;
  .tip-icon {
    margin-left: 3px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #9c9c9c;
    color: #a8a6a6;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 9999;
    display: block;
  }
  .pop-tip {
    position: absolute;
    width: 190px;
    bottom: -40px;
    display: flex;
    align-items: center;
    text-align: left;
    left: 50%;
    margin-left: -0px;
    padding: 3px 10px;
    display: flex;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      left: 29px;
      transform: rotateZ(135deg);
    }
  }
}
.tools-box{
  justify-content: flex-start;
}
.ivu-modal-footer{
  text-align: right;
}
.my-modal{
  .ivu-modal-footer {
    padding-bottom:40px;
    z-index: 1000;
    .ivu-btn {
      min-width: 100px;
      margin-right: 10px;
      &:last-child{
        margin-right: 12px;
      }
    }
  }
}

/deep/ .ivu-table-tip table {
    min-height: 180px;
  }
</style>